var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 7.53497V17C22 17.7652 21.7077 18.5015 21.1827 19.0582C20.6578 19.615 19.9399 19.9501 19.176 19.995L19 20H5C4.23479 20 3.49849 19.7076 2.94174 19.1827C2.38499 18.6577 2.04989 17.9399 2.005 17.176L2 17V7.53497L11.445 13.832L11.561 13.898C11.6977 13.9648 11.8478 13.9995 12 13.9995C12.1522 13.9995 12.3023 13.9648 12.439 13.898L12.555 13.832L22 7.53497Z",
    fill: "#344054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 4C20.0798 4 21.0268 4.57 21.5548 5.427L11.9998 11.797L2.44482 5.427C2.69562 5.01982 3.04011 4.6785 3.4496 4.43149C3.85908 4.18448 4.32168 4.03894 4.79882 4.007L4.99982 4H18.9998Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon_email.750288abd95cabdd9bc5b27536645ec1.svg";
export { ForwardRef as ReactComponent };